import {UseQueryOptions, QueryKey} from '@tanstack/react-query'
import {WorkspaceProfile} from 'types'
import {getCurrentWorkspace} from './workspaceApi'

export const CURRENT_WORKSPACE = 'currentWorkspace'
export const WORKSPACE_QUERY_KEY = 'workspace'

export const getCurrentWorkspaceOptions = (
	options?: UseQueryOptions<
		WorkspaceProfile,
		Error,
		WorkspaceProfile,
		QueryKey
	>,
) => {
	const queryOptions: UseQueryOptions<
		WorkspaceProfile,
		Error,
		WorkspaceProfile,
		QueryKey
	> = {
		queryKey: [WORKSPACE_QUERY_KEY, CURRENT_WORKSPACE],
		queryFn: () => getCurrentWorkspace(),
		...options,
	}
	return queryOptions
}
